import { csrfToken, url2link } from '@/js/_common';

const setCloseEvent = (element) => {
    element.querySelector('.c-parts-news__close').addEventListener('click', (e) => {
        e.currentTarget.closest('.c-parts-news').remove();
        const id = e.currentTarget.closest('.c-parts-news').dataset.id;
        fetch(`/api/user/news/read/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            }
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return resp.json();
        }).catch((error) => {
            console.error('There has been a problem with your fetch operation:', error);
        })
    });
}

const setToggleEvent = (element) => {
    element.querySelector('.c-parts-news__title').addEventListener('click', (e) => {
        const state = e.currentTarget.closest('.c-parts-news').dataset.open;
        e.currentTarget.closest('.c-parts-news').dataset.open = state === '1' ? 0 : 1;
    });
}

const main = () => {
    if (document.querySelector('.c-parts-news') == null) return;

    document.querySelectorAll('.c-parts-news').forEach((el) => {
        setCloseEvent(el);
        setToggleEvent(el);
        url2link('.c-parts-news__content');
    });
}

export default main;
